// Add your custom JS here.

// +ADD: init
document.addEventListener('DOMContentLoaded', () => {
	// Lightboxok (nincs caption, mert nincs data-title átadva)
	GLightbox({ selector: '.glightbox-photos' });
	GLightbox({ selector: '.glightbox-floorplans' });

	// Swiper minden galériára
	document.querySelectorAll('.gallery-swiper').forEach((el) => {
		new Swiper(el, {
			slidesPerView: 1.2,
			spaceBetween: 12,
			centeredSlides: false,
			loop: false,
			pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
			navigation: {
				nextEl: el.querySelector('.swiper-button-next'),
				prevEl: el.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				576: { slidesPerView: 2.2 },
				768: { slidesPerView: 3 },
				992: { slidesPerView: 4 },
				1200: { slidesPerView: 5 },
			},
		});
	});
});

/**
 * === Terra-Ép Smooth Scroll System ===
 * Egységes, univerzális smooth scroll logika linkekhez és gombokhoz.
 *
 * ✅ Használat:
 * - Bármely <a href="#valami"> automatikusan smooth scrollt kap.
 * - Ha nem <a>, hanem pl. <button> vagy <div>, add hozzá:
 *     data-scroll data-scroll-target="#valami"
 *
 * 💡 Opcionális attribútumok:
 * - data-scroll-offset="-40"     → extra függőleges eltolás (pl. fix header miatt)
 * - data-update-hash="false"     → ne frissítse a böngésző hash-t
 *
 * ⚙️ Beállítások:
 * - HEADER_SELECTOR: fix header szelektor (pl. .site-header)
 * - FALLBACK_OFFSET: ha nincs header, ennyit von le (px)
 *
 * Példák:
 *   <a href="#kapcsolat">Ugrás a kapcsolathoz</a>
 *   <button data-scroll data-scroll-target="#prop-contact">Időpontot kérek</button>
 *   <a href="#gyik" data-scroll-offset="-60">Gyakori kérdések</a>
 *
 * Automatikusan kezeli:
 * - az oldal betöltéskori hash görgetést (#anchor a URL-ben)
 * - a vissza / előre navigációt (popstate)
 * - fókuszt ad a cél elemnek akadálymentesítéshez
 */

// Smooth scroll – univerzális, 1 modul
(() => {
	const HEADER_SELECTOR = '.site-header, header.sticky-top';
	const FALLBACK_OFFSET = 80;
	const SCROLL_BEHAVIOR = 'smooth';

	const getHeaderOffset = () => {
		const h = document.querySelector(HEADER_SELECTOR);
		const hh = h ? Math.ceil(h.getBoundingClientRect().height) : FALLBACK_OFFSET;
		return -Math.max(0, hh);
	};

	const smoothTo = (elOrSelector, extraOffset = 0, updateHash = true) => {
		const el = typeof elOrSelector === 'string' ? document.querySelector(elOrSelector) : elOrSelector;
		if (!el) return;
		const y = el.getBoundingClientRect().top + window.pageYOffset + getHeaderOffset() + extraOffset;
		window.scrollTo({ top: y, behavior: SCROLL_BEHAVIOR });
		if (updateHash && el.id) history.pushState(null, '', `#${el.id}`);
		el.setAttribute('tabindex', '-1');
		el.focus({ preventScroll: true });
	};

	// Delegált kattintás: működik linkre és data-scroll-os elemekre
	document.addEventListener('click', (e) => {
		const trigger = e.target.closest('[data-scroll], a[href^="#"]:not([data-no-smooth])');
		if (!trigger) return;

		// 1) data-scroll eset: olvassuk a targetet
		let selector = trigger.dataset.scrollTarget;

		// 2) ha link és nincs data-scroll-target, akkor href az ID
		if (!selector && trigger.tagName === 'A') {
			const href = trigger.getAttribute('href');
			if (!href || href === '#') return; // ignore dummy
			selector = href;
		}
		if (!selector) return;

		const target = document.querySelector(selector);
		if (!target) return;

		e.preventDefault();
		const updateHash = trigger.dataset.updateHash !== 'false'; // opcionális
		const extra = parseInt(trigger.dataset.scrollOffset || '0', 10) || 0;
		smoothTo(target, extra, updateHash);
	});

	// Hash-es belépéskor is gördítsen szépen
	const handleInitialHash = () => {
		if (location.hash.length > 1) {
			const t = document.querySelector(location.hash);
			if (t) setTimeout(() => smoothTo(t, 0, false), 0);
		}
	};
	document.addEventListener('DOMContentLoaded', handleInitialHash);
	window.addEventListener('popstate', () => {
		if (location.hash.length > 1) {
			const t = document.querySelector(location.hash);
			if (t) smoothTo(t, 0, false);
		}
	});
})();
